import { render, staticRenderFns } from "./ModalCadastroOcorrencia.vue?vue&type=template&id=0d39b886"
import script from "./ModalCadastroOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalCadastroOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports